import { VStack } from '@chakra-ui/react';
import { FormProvider, useForm } from 'react-hook-form';

import { useFormAutosave } from 'shared_DEPRECATED/hooks';

import {
  SessionSidebarFieldsetLabel,
  SessionSidebarLabel,
} from 'features/sessions/components';
import {
  NextSessionCoachingToolsSection,
  NextSessionFormMiroBoardLinkField,
  NextSessionNotes,
  ParticipantProfileNote,
} from 'features/sessions/components/NextSessionForm';
import {
  NextSessionSidebarHeader,
  NextSessionUserInfo,
} from 'features/sessions/components/NextSessionForm/Sidebar';
import { RedirectToSessionsIfNoNextSession } from 'features/sessions/components/NextSessionForm/Sidebar/RedirectToSessionsIfNoNextSession';
import { CoachSessionNextSessionInfo } from 'features/sessions/components/NextSessionInfo';
import { SessionPrepInfo } from 'features/sessions/config/types';
import { useNextSessionUpdate } from 'features/sessions/hooks/useNextSessionUpdate';

type NextSessionCoachFormPropTypes = {
  sessionAppointment: SessionPrepInfo;
};

export const NextSessionCoachFormWithHeader = ({
  sessionAppointment,
}: NextSessionCoachFormPropTypes) => {
  const formMethods = useForm<SessionPrepInfo>({
    defaultValues: {
      ...sessionAppointment,
    },
  });

  const onMutate = useNextSessionUpdate(formMethods);

  useFormAutosave({
    formMethods,
    onMutate,
    storageKey: `nextSession-${sessionAppointment.nextSessionAppointment.coachingSessionId}`,
  });

  return (
    <FormProvider {...formMethods}>
      <NextSessionSidebarHeader
        onNextSessionSave={formMethods.handleSubmit(onMutate)}
        clientEmail={sessionAppointment.nextSessionAppointment.clientEmail}
        coachingSessionId={
          sessionAppointment.nextSessionAppointment.coachingSessionId
        }
      />
      <NextSessionUserInfo />
      <RedirectToSessionsIfNoNextSession>
        <VStack alignItems="flex-start">
          <SessionSidebarFieldsetLabel>
            Next session date and time
          </SessionSidebarFieldsetLabel>
          <CoachSessionNextSessionInfo />
        </VStack>
      </RedirectToSessionsIfNoNextSession>
      <NextSessionNotes />
      <NextSessionCoachingToolsSection />
      <SessionSidebarLabel>Participant profile</SessionSidebarLabel>
      <NextSessionFormMiroBoardLinkField />
      <ParticipantProfileNote />
    </FormProvider>
  );
};
